(function () {
  "use strict";

  const ROOT_SELECTOR = "[js-perfect-gift]";

  /** Shortest signed distance on a ring (e.g. last → first keeps a right neighbor). */
  function circularOffset(frameIndex, activeIndex, total) {
    let diff = frameIndex - activeIndex;
    const half = Math.floor(total / 2);
    if (diff > half) diff -= total;
    if (diff < -half) diff += total;
    return diff;
  }

  function slotFromOffset(offset) {
    if (offset === 0) return "center";
    if (offset === -1) return "left";
    if (offset === 1) return "right";
    return "hidden";
  }

  function initPerfectGift(root) {
    if (!root || root.dataset.perfectGiftInit === "true") return;
    root.dataset.perfectGiftInit = "true";

    const frames = Array.from(root.querySelectorAll("[js-perfect-gift-frame]"));
    const count = frames.length;
    if (!count) return;

    let activeIndex = 0;
    let timerId = null;
    let paused = false;

    const setActive = (index) => {
      activeIndex = index;
      frames.forEach((frame, i) => {
        frame.dataset.slot = slotFromOffset(circularOffset(i, index, count));
      });
      root.style.setProperty("--perfect-gift-active-index", String(index));
    };

    setActive(0);

    if (count === 1) return;

    const autoplayEnabled = root.dataset.autoplay !== "false";
    if (!autoplayEnabled) return;

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    let delayMs = parseInt(root.dataset.autoplayMs, 10);
    if (isNaN(delayMs) || delayMs < 2000) delayMs = 2000;

    const stopAutoplay = () => {
      if (timerId !== null) {
        window.clearInterval(timerId);
        timerId = null;
      }
    };

    const startAutoplay = () => {
      stopAutoplay();
      if (paused || count < 2) return;
      timerId = window.setInterval(() => {
        setActive((activeIndex + 1) % count);
      }, delayMs);
    };

    const pause = () => {
      paused = true;
      root.classList.add("is-paused");
      stopAutoplay();
    };

    const resume = () => {
      paused = false;
      root.classList.remove("is-paused");
      startAutoplay();
    };

    const stage = root.querySelector(".perfect-gift__stage") || root;

    stage.addEventListener("mouseenter", pause);
    stage.addEventListener("mouseleave", resume);
    stage.addEventListener("focusin", pause);
    stage.addEventListener("focusout", (event) => {
      if (!root.contains(event.relatedTarget)) resume();
    });

    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        stopAutoplay();
      } else if (!paused) {
        startAutoplay();
      }
    });

    startAutoplay();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(initPerfectGift);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    const root = event.target.querySelector(ROOT_SELECTOR);
    if (root) initPerfectGift(root);
  });
})();
